import { SummaryHighlight } from '../../common/summaryHighlight'

export const Highlight = () => {
  return <SummaryHighlight />
}
